module.exports = __webpack_public_path__ + "static/DMSans-BoldItalic-068e6c812107ac6dd3b1850c959c7736.woff";